import { render, staticRenderFns } from "./TicketsSystemListItem.vue?vue&type=template&id=486b400a&"
import script from "./TicketsSystemListItem.vue?vue&type=script&lang=js&"
export * from "./TicketsSystemListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports